import styled from 'styled-components';

export const Wrapper = styled.button`
  border: none;
  outline: none;
  flex: 1;
  justify-content: center;
  cursor: pointer;
  background: none;
  /* padding: 10px; */
`;
